import { Col, EmphasisBlock, EmphasisBlockProps, media } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledLeftCol = styled(Col)`
  display: flex;
  text-align: center;
  margin-bottom : 0px;
  flex:1;
  button {
    width: 100%;
  }

  ${media.sm`
    display: block;
    text-align: left;
    button {
    width: auto;
  }
  `};
`;

export const StyledRightCol = styled(Col)`
  display: block;
  margin-top:32px;

  ${media.sm`
    display: flex;  
    justify-content: flex-end;
    text-align: left;
    margin-top:0px;
  `};
`;

export const StyledEmphasisBlock = styled<FC<EmphasisBlockProps>>(EmphasisBlock)`
  padding-right: 33px !important;
  padding-bottom : 37px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;
